import React from "react";

const ResultPapperForm = ({ 
  publicResultPaper,
  ooResultClick 
}) => {
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-result">
            <header className="result-header">
              <h1 className="top-title">AI스캐닝 수학 진단평가</h1>
            </header>
            <main className="result-main">
              <div className="result-main-wrap">
                <div className="rm-top">
                  <h2 className="rm-top-title">
                    <span className="ai-user">{publicResultPaper.name}</span>
                    <span className="ai-txt">
                      학생의 AI스캐닝 수학 진단평가 시험 결과
                    </span>
                  </h2>
                  <div className="rm-top-date">
                    <span>평가일자:</span>
                    <span>
                      {String(publicResultPaper.start_dt).substr(0, 4)}년{" "}
                      {String(publicResultPaper.start_dt).substr(5, 2)}월{" "}
                      {String(publicResultPaper.start_dt).substr(8, 2)}일
                    </span>
                  </div>
                </div>
              </div>
              <div className="question_page active_page">
                  <div id="question_list">
                    <section className="marking_box">
                      <ul>
                        {
                          publicResultPaper.result.map((value, index) => {
                            return (
                              <li className={value.is_right? "o" : "x"} data-seq={index} key={index}>
                                <p>{index + 1}</p>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </section>

                    <section className="problem_list">
                      {
                        publicResultPaper.result.map((value, index) => {
                          return (
                            <div className="preload_page" key={index}>
                              <article className="problem_box">
                                <div className="level_nav">
                                  <dl>
                                    <dt>영역</dt>
                                    <dd className="part">{value.domain}</dd>
                                    <dt>입력</dt>
                                    <dd className="correct">{value.ansinput}</dd>
                                    <dt>정답</dt>
                                    <dd className="correct">{value.problem_answer}</dd>
                                  </dl>
                                </div>
                                <div className="iframe_question">
                                  <iframe 
                                    src={`${process.env.REACT_APP_API_SERVER}/diagnosis/api/result/paper/problem_view/${index + 1}/${value.problem_id}/${value.ansinput}`} 
                                    width="1200" 
                                    height="560"
                                    title={`ai-quiz-iframe-${index + 1}`}
                                  ></iframe>
                                </div>
                              </article>
                            </div>
                          )
                        })
                      }
                    </section>
                  </div>
              </div>
              
              <div className="rm-button">
                    <button
                      className="button-bottom button-ai-go"
                      onClick={ooResultClick}
                    >
                      진단평가 결과보기
                    </button>
                  </div>
            </main>
          </div>
        </div>
        
      </div>
    </>
  );
};
//
export default ResultPapperForm;
